import { AlertTriangle } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Link, useRouteError } from "react-router-dom"

import { ContentLayout } from "@/components/layouts"
import { Button } from "@/components/ui/button"

export default function ErrorPage() {
  const error = useRouteError()
  console.error(error)

  const { t } = useTranslation()

  return (
    <ContentLayout title={t("ErrorTitle")}>
      <div
        className="flex h-full flex-col items-center justify-center text-center px-4"
        role="alert"
      >
        <div className="text-red-500 mb-4">
          <AlertTriangle size={48} />
        </div>
        <h2 className="text-xl font-semibold text-red-600 mb-2">
          {t("ErrorTitle") || "Ooops, something went wrong!"}
        </h2>
        <p className="text-sm text-gray-500 mb-6 max-w-md">
          {t("ErrorDescription") ||
            "We encountered an error while loading this page. There might be a connection issue, data not found, or system disruption."}
        </p>
        <div className="flex gap-2">
          <Button variant="secondary" asChild>
            <Link to="/" replace>
              {t("GoToHome") || "Go to Home"}
            </Link>
          </Button>
          <Button
            onClick={() => window.location.assign(window.location.origin)}
          >
            {t("Refresh") || "Refresh"}
          </Button>
        </div>
      </div>
    </ContentLayout>
  )
}
